class ProductMedia extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slider', 'slide']
  }

  setupListeners () {
    if (!window.KeenSlider || !window.BAO?.Carousel?.plugins) return

    const { setInitialised, useArrows } = window.BAO.Carousel.plugins
    const plugins = [
      setInitialised(),
      useArrows({
        container: this.els.arrows?.element,
        next: this.els.next?.element,
        previous: this.els.previous?.element,
      }),
      this.useMappedDots(this.els.thumbnailDot?.elements),
      this.useMappedDots(this.els.paginationDot?.elements),
    ]

    this.carousel = new window.KeenSlider(
      this.els.slider.element,
      {
        selector: this.els.slide.selector,
        loop: this.els.slide.elements.length > 1,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 5,
        },
        breakpoints: {
          '(min-width: 750px) and (max-width: 989px)': {
            disabled: true,
          },
          '(min-width: 990px)': {
            disabled: false,
            slides: {
              perView: 1,
              spacing: 0,
            },
          },
        },
      },
      plugins,
    )

    // Variant changes reorder slides; refresh Keen so navigation and current index stay correct.
    this.observer = new MutationObserver(() => {
      if (!this.carousel) return
      this.carousel.update()
      this.carousel.moveToIdx(0)
    })

    this.observer.observe(this.els.slider.element, { childList: true })
  }

  disconnectedCallback () {
    super.disconnectedCallback()
    this.observer?.disconnect()
    this.carousel?.destroy()
  }

  useMappedDots (dots = []) {
    return (carousel) => {
      if (!dots.length) return

      const updateDotStates = () => {
        const currentIndex = carousel.track.details.rel
        const currentSlide = carousel.slides[currentIndex]
        const currentMediaId = currentSlide?.dataset.mediaId

        dots.forEach((dot, index) => {
          const dotMediaId = dot.dataset.mediaId
          const targetIndex = Number(dot.dataset.index)
          const mappedIndex = Number.isNaN(targetIndex) ? index : targetIndex
          const isCurrent = dotMediaId
            ? dotMediaId === currentMediaId
            : currentIndex === mappedIndex

          dot.setAttribute('aria-current', String(isCurrent))
        })
      }

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          const targetIndex = Number(dot.dataset.index)
          const mappedIndex = Number.isNaN(targetIndex) ? index : targetIndex
          carousel.moveToIdx(mappedIndex)
        })
      })

      carousel.on('created', updateDotStates)
      carousel.on('slideChanged', updateDotStates)
      carousel.on('updated', updateDotStates)
    }
  }
}

if (!customElements.get('product-media')) {
  customElements.define('product-media', ProductMedia)
}
